import { useState, useEffect } from 'react';

interface AuthStatus {
  isAuthenticated: boolean;
  isLoading: boolean;
}

/**
 * Hook que verifica si el usuario viene del sistema padre
 * El usuario está autenticado si:
 * 1. Existe clientRolsIds en localStorage (indica que se recibió un postMessage con token)
 * 2. O la aplicación está dentro de un iframe (window.self !== window.top)
 */
const useAuthCheck = (): AuthStatus => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      // Permitir acceso en localhost para desarrollo
      const isLocalhost = 
        window.location.hostname === 'localhost' || 
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname === '';

      // Verificar si hay clientRolsIds en localStorage (indica que se recibió un postMessage)
      const clientRolsIds = localStorage.getItem('clientRolsIds');
      const hasStoredRoles = clientRolsIds && clientRolsIds !== '[]' && clientRolsIds !== 'null';

      // Verificar si la aplicación está dentro de un iframe
      const isInIframe = window.self !== window.top;

      // El usuario está autenticado si:
      // 1. Está en localhost (desarrollo)
      // 2. Tiene roles almacenados O está en un iframe
      const authenticated = isLocalhost || hasStoredRoles || isInIframe;

      setIsAuthenticated(authenticated);
      setIsLoading(false);
    };

    // Verificar inmediatamente
    checkAuth();

    // También escuchar cambios en localStorage por si el postMessage llega después
    const handleStorageChange = () => {
      checkAuth();
    };

    window.addEventListener('storage', handleStorageChange);

    // Verificar periódicamente por si el postMessage tarda en llegar
    const interval = setInterval(checkAuth, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  return { isAuthenticated, isLoading };
};

export default useAuthCheck;


